'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';
import croppieModal from '../../modules/croppieModal';

const quizIndex = {
  init() {
    croppieModal.init();

    $(document).on('click', '.js-btn-next', function(e) {
      e.preventDefault();
      let currentTab = $(this).attr('data-current');

      if ($("input[name='" + currentTab + "']:checked").val() == null) {
        Swal.fire('Atenção', 'Você precisa escolher uma opção', 'warning');
      } else {
        $('#' + currentTab).removeClass('s-quiz--tab-active');
        $('#' + $(this).attr('data-next')).addClass('s-quiz--tab-active');
      }
    });
  },
};

export default quizIndex;
